import { __awaiter } from "tslib";
import conf from '../../conf';
import fetch from '../fetch';
export const getCybersourceFormData = (currency, signupData, setFormData) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(dispatch)(`${conf.API_URL}/api/cybersource/signature?currency=${currency}`, {
        method: 'POST',
        body: JSON.stringify(signupData),
    });
    if (!res.ok)
        return;
    setFormData(res.value);
});
